import { convertToLocale } from "@lib/util/money";
import type { StoreCartLineItem, StoreOrderLineItem } from "@medusajs/types";
import { clx } from "@medusajs/ui";

type LineItemUnitPriceProps = {
  item: StoreCartLineItem | StoreOrderLineItem;
  style?: "default" | "tight";
  currencyCode: string;
};

const LineItemUnitPrice = ({ item, style = "default", currencyCode }: LineItemUnitPriceProps) => {
  const { total, original_total } = item;
  const hasReducedPrice = total < original_total;

  const percentage_diff = Math.round(((original_total - total) / original_total) * 100);

  return (
    <div className="flex flex-col text-ui-fg-muted justify-center h-full">
      {hasReducedPrice && (
        <>
          <p>
            {style === "default" && <span className="text-ui-fg-muted">Original: </span>}
            <span className="line-through" data-testid="product-unit-original-price">
              {convertToLocale({
                amount: original_total / item.quantity,
                currency_code: currencyCode,
              })}
            </span>
          </p>
          {style === "default" && <span className="text-ui-fg-interactive">-{percentage_diff}%</span>}
        </>
      )}
      <span
        className={clx("text-base-regular", {
          "text-ui-fg-interactive": hasReducedPrice,
        })}
        data-testid="product-unit-price"
      >
        {convertToLocale({
          amount: total / item.quantity,
          currency_code: currencyCode,
        })}
      </span>
    </div>
  );
};

export default LineItemUnitPrice;
